@if (cookies.showBanner) {
  <div class="cookies-banner">
    <p style="font-weight: bold; white-space: nowrap">
      {{ "cookies.MANAGECONSENT" | translate }}
    </p>
    <div class="text">
      {{ "cookies.SHORTDESCRIPTION" | translate }}
    </div>
    <div class="actions">
      <button class="btn accept" (click)="accept()">
        {{ "cookies.ACCEPT" | translate }}
      </button>
      <button class="btn more" (click)="openMoreDialog()">
        {{ "cookies.MORE" | translate }}
      </button>
    </div>
  </div>
}
